import * as React from "react"
export const Svg_044 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M43.893 9.59h1.364V4.907h-4.602v1.387c0 1.816 1.453 3.294 3.238 3.294Z"
    />
    <path
      fill="url(#b)"
      d="M14.107 22.195h-1.364v4.681h4.602V25.49c0-1.816-1.453-3.294-3.238-3.294Z"
    />
    <path
      fill="url(#c)"
      d="M40.655 25.49v1.387h4.602v-4.682h-1.364c-1.785 0-3.238 1.478-3.238 3.294Z"
    />
    <path
      fill="url(#d)"
      d="M0 47.558c0 3.603 2.882 6.534 6.423 6.534h45.154c3.542 0 6.423-2.931 6.423-6.534v-.38H0v.38Z"
    />
    <path
      fill="url(#e)"
      d="M14.107 13.046h-1.364v5.692h1.364c3.66 0 6.636 3.029 6.636 6.751v1.387h16.514V25.49c0-3.722 2.977-6.751 6.636-6.751h1.364v-5.692h-1.364c-3.66 0-6.636-3.028-6.636-6.751V4.908H20.743v1.387c0 3.723-2.977 6.751-6.636 6.751ZM27.3 14.164h3.398v3.457h-3.398v-3.457Z"
    />
    <path
      fill="url(#f)"
      d="M14.107 9.59c1.785 0 3.238-1.479 3.238-3.295V4.908h-4.602v4.681h1.364Z"
    />
    <path
      fill="url(#g)"
      d="M54.602 11.822h-5.946v18.512H9.344V11.822H3.398v31.9h51.204v-31.9Zm-30.7 28.442h-3.398v-6.473h3.398v6.473Zm6.797 0h-3.398v-6.473h3.398v6.473Zm6.797 0h-3.398v-6.473h3.398v6.473Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={41.719}
        x2={43.96}
        y1={5.61}
        y2={9.175}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={13.807}
        x2={16.048}
        y1={22.897}
        y2={26.462}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={41.719}
        x2={43.96}
        y1={22.897}
        y2={26.462}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.412}
        x2={13.95}
        y1={48.215}
        y2={55.52}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={20.262}
        x2={28.558}
        y1={8.203}
        y2={28.076}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={13.807}
        x2={16.048}
        y1={5.61}
        y2={9.175}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={15.239}
        x2={26.599}
        y1={16.607}
        y2={46.119}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)